export default __webpack_public_path__ + "static/3-86af863211891547154fcdd74af124c4.png";